import { createContext } from "react";

export { default as TrackingManager } from "./TrackingManager";
export { default as DataManager } from "./DataManager";
export { default as WidgetOfferManager } from "./WidgetOfferManager";
export { default as PDPManager } from "./PDPManager";
export { default as VisibleGroupsManager } from "./VisibleGroupsManager";
export { default as ModeManager } from "./ModeManager";
export { default as UserManager } from "./UserManager";
export { default as CacheManager } from "./CacheManager";
export { default as PingManager } from "./PingManager";
export { default as ViewportManager } from "./ViewportManager";
export { default as PerformanceManager } from "./PerformanceManager";
export { default as ImpressionManager } from "./ImpressionManager";
export { default as IntersectionManager } from "./IntersectionManager";
export { default as PreviewManager } from "./PreviewManager";

export const CacheContext = createContext();
export const TrackingContext = createContext();
export const UserContext = createContext();
export const DataContext = createContext();
export const PDPContext = createContext();
export const VisibleGroupsContext = createContext();
export const ModeContext = createContext();
export const PingContext = createContext();
export const ViewportContext = createContext();
export const ImpressionContext = createContext();
export const IntersectionContext = createContext();
export const OfferContext = createContext();
